<template>
    <div class="main-content">

        <!-- NavBar -->
        <div class="container-fluid top-course-bar" style="overflow: visible" v-if="!isAndroidApp()">
            <div class="container">
                <div class="row justify-content-xl-left justify-content-between justify-content-sm-around">
                    <div class="col-auto col-lg px-sm-0 order-1 order-sm-1">
                        <div class="pt-1 pb-1 ml-xl-0 ml-4">
                            <router-link slot="brand" class="top-course-bar-brand text-sm-center" to="/" :title="$t('to_homepage')">
                                <img src="poliimg/ic_back.png" class="mr-1"/><span class="d-sm-inline d-none">{{ $t('to_homepage') }}</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-auto col-lg order-2 order-sm-2 text-center px-sm-0 d-block top-select-course-wrapper">
                        <base-dropdown class="nav-item top-select-course pb-1" position="left">
                            <a slot="title" class="nav-link pt-1 pb-1" href="javascript:void(0);" role="button">
                                <span class="nav-link-inner--text mr-1">{{ $t('my_courses') }}</span><i
                                    class="fa fa-chevron-down"></i>
                            </a>

                            <div class="dropdown-header noti-title">
                                <h6 class="text-overflow m-0">{{ $t('my_courses') }} <i class="fa fa-chevron-up"></i></h6>
                            </div>
                            <router-link v-for="item in orderedCourses"
                                         :key="item.idcourse"
                                         :to="`/course/${item.slug}`" class="dropdown-item">
                                <span class="nav-link-inner--text">{{item.course}}</span>
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link to="/courses" class="dropdown-item">
                                <span class="nav-link-inner--text">{{ $t('take_courses') }}</span>
                            </router-link>
                        </base-dropdown>
                    </div>
                    <div class="col-auto col-lg  pl-0 px-sm-0 order-3 order-sm-3 ml-xl-auto ml-0 text-sm-right">
                        <base-dropdown class="nav-item mr-xl-0 mr-lg-4 mr-sm-0" position="right" v-if="user">
                            <a slot="title" class="nav-link" href="javascript:void(0);" role="button">
                                <div class="media align-items-center">
                                    <i class="fa fa-chevron-down mr-2"></i>
                                    <span class="rounded-circle">
                                <img src="poliimg/ic_user_top.png"/>
                              </span>
                                </div>
                            </a>

                            <div class=" dropdown-header noti-title" v-if="user">
                                <h6 class="text-overflow m-0" v-if="user.email">{{ user.email }}</h6>
                                <h6 class="text-overflow m-0" v-else-if="user.phone">{{ user.phone }}</h6>
                            </div>
                            <router-link to="/user/profile" class="dropdown-item">
                                <i class="ni ni-single-02"></i>
                                <span>{{ $t('my_profile') }}</span>
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link to="/user/logout" class="dropdown-item">
                                <i class="ni ni-user-run"></i>
                                <span>{{ $t('logout') }}</span>
                            </router-link>
                        </base-dropdown>
                        <base-dropdown class="nav-item mr-xl-0 mr-4" position="right" v-else>
                            <a slot="title" class="nav-link" href="javascript:void(0);" role="button">
                                <div class="media align-items-center">
                                    <i class="fa fa-chevron-down mr-2"></i>
                                    {{ $t('login') }} / {{ $t('register') }}
                                </div>
                            </a>

                            <router-link to="/user/signin" class="dropdown-item">
                                <i class="ni ni-single-02"></i>
                                <span>{{ $t('login') }}</span>
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link to="/user/signin" class="dropdown-item">
                                <i class="ni ni-user-run"></i>
                                <span>{{ $t('do_register') }}</span>
                            </router-link>
                        </base-dropdown>

                    </div>

                </div>
            </div>
        </div>


        <!-- Page content -->
        <router-view></router-view>

        <!-- Footer -->
        <footer v-if="!isAndroidApp()">
            <div class="container-fluid bg-green-letters poli-footer-line-1 footer pt-0 pb-0">
                <div class="container">
                    <div class="row align-items-center justify-content-xl-between">
                        <div class="col-xl-7 text-center text-xl-left">
                            <a href="https://www.poliglotiki.ru/"
                               target="_blank"><img :src="$t('logo_yellow')" class="mt-3 mb-3"/> </a>
                        </div>
                        <div class="col-xl-3 text-center text-xl-left">
                            <div class="f-soc-nets d-none d-xl-block">{{ $t('we_in_socials') }}:</div>
                            <div class="f-soc-nets-btns mb-3 mb-xl-0">
                                <a v-if="$t('yt_link')" :href="$t('yt_link')" class="ytb" target="_blank" rel="nofollow"></a>
                                <a v-if="$t('inst_link')" :href="$t('inst_link')" class="insta" target="_blank" rel="nofollow"></a>
                                <a v-if="$t('vk_link')" :href="$t('vk_link')" class="vk" target="_blank" rel="nofollow"></a>
                                <a v-if="$t('fb_link')" :href="$t('fb_link')" class="fb" target="_blank" rel="nofollow"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid poli-footer-line-2">
                <div class="container  pt-3 pb-3">
                    <div class="row align-items-center justify-content-xl-between">
                        <div class="col-xl-7 order-2 order-xl-1">
                            <div class="copyright text-center text-xl-left">
                                &copy; <a href="https://www.poliglotiki.ru/" class="font-weight-bold ml-1"
                                          target="_blank">{{ $t('start_year_copy') }}{{year}} {{ $t('POLIGLOTIKI') }}</a>
                                <span class="d-none d-xl-inline">&nbsp;-&nbsp;</span>
                                <span class="d-block d-xl-inline">{{ $t('footer_slogan') }}</span>
                            </div>
                        </div>
                        <div class="col-xl-3 order-1 order-xl-2 mb-xl-0 mb-4">
                            <div class="copyright text-center text-xl-left text-muted">
                                <router-link to="/entry" class="ml-1 footer-callback">{{ $t('callback') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<style>
    .top-select-course.dropdown.show ul.dropdown-menu {
        margin-top: -48px !important;
        margin-left: -20px !important;
        min-width: 17rem;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
    }
</style>
<script>

    import {getUser} from "../data/jwt.service";
    import courseApi from "../data/CourseApi";
    import {isAndroid} from "../data/AndroidApi";

    export default {
        name: 'course-layout',
        data() {
            return {
                year: new Date().getFullYear(),
                showMenu: false,
                user: null,
                orderedCourses: [],
            }
        },
        mounted() {
            console.log("isAndroid", isAndroid())
            this.user = getUser()
            courseApi.fetchCoursesWithFilter(null, null, null)
                .then(response => {
                    this.orderedCourses = response.filter((el) => {
                        return el.ordered
                    })
                    //console.log(this.orderedCourses)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        methods: {
            isAndroidApp() {
                return isAndroid()
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            }
        }
    }
</script>
<style>
</style>
